module.exports = __webpack_public_path__ + "static/media/dmvi_logo.38b2358c.png";